export const Environment = {
  discovery: 'https://api-nowotv.nowo.pt/api/v1/bootstrap/discover',
  system: 'SMARTTV_TIZEN',
  Oauth: {
    clientId: 'androme.tv-smarttv-tizen-1',
    redirectUri: 'https://nowotv.nowo.pt',
    uri: 'https://api-nowotv.nowo.pt/api/oauth/v1/auth/authorize',
    secret: '4NNSDOEeSXYMPzQPMtFK',
  },
  Castlabs: {
    licenseKey:
      'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJpbHYiOmZhbHNlLCJ0eXBlIjoiV2ViIiwidXJscyI6WyJodHRwczovL3d3dy1ub3dvLmRldi5uZWJ1bGEuYW5kcm9tZS5jb20iXSwia2lkIjoxNjg4fQ.HXxOv_yApBrF64E1kyHDL-lyHAWyUJrUvc0PvNq1PTlrNbqqEVMRy9QB2PcylFbidYvGXee8GVl8pmb52pL0QRnmQK6Qbd99fFovK0ot7qV73NaVpRRcDNVZ3hTgrFlcUWtnV0eQicps48jjTWFZfLjkgqz4h-Wes7JG6FxZ4erD9yeiyBOD_cG7ykfaeAXIU-RkTYeyyfkxcqEG3ibb8Q6QCysZQPUmZAIu7QSeFhoL6YWSLFiXNbry0Hyk0mjLHyNIvJWARWceTwi0Hc3xryvYCLMv2cLfUl0nCBEm6fDKFcSaPG9UniKFBCY4dzHWux30t7YlcQKUuWP1jM2Kzw',
    drmMerchant: 'cabovisao',
    drmEnvironment: 'DRMtoday',
    drmStaging: false,
    defaultDrmProvider: 'PLAYREADY',
  },
  atv_ott_rights: ['LINEAR', 'NPVR'],
  atv_replay_ott_rights: ['REPLAY'],
};
